import { Outlet } from 'react-router-dom';
import { Fragment } from 'react';
import { toAbsoluteUrl } from '@/utils';
import useBodyClasses from '@/hooks/useBodyClasses';
import { AuthBrandedLayoutProvider } from './AuthBrandedLayoutProvider';

const Layout = () => {
  // Applying body classes to manage the background color in dark mode
  useBodyClasses('dark:bg-coal-500');

  return (
    <Fragment>
      <div
        className="grid lg:grid-cols-2 grow contrast:!bg-black h-dvh"
        data-testid="auth-branded-layout-grid"
      >
        <main
          id="main-content"
          className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1 auth-main"
          data-testid="auth-content-container"
        >
          <Outlet />
        </main>

        <div
          className="lg:rounded-xl flex justify-center items-center gap-2 lg:border lg:border-gray-200 order-1 lg:m-5 bg-primary lg:order-2 bg-no-repeat bg-cover bg-center"
          data-testid="auth-branded-section"
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/app/mini-logo.webp')})`,
          }}
          aria-hidden="true"
        ></div>
      </div>
    </Fragment>
  );
};

// AuthBrandedLayout component that wraps the Layout component with AuthBrandedLayoutProvider
const AuthBrandedLayout = () => (
  <AuthBrandedLayoutProvider>
    <Layout />
  </AuthBrandedLayoutProvider>
);

export { AuthBrandedLayout };
